import twenty from './2020/2020-awards-dropdown-menu';
import twentyOne from './2021/2021-awards-dropdown-menu';
import twentyTwo from './2022/2022-awards-dropdown-menu';
import twentyThree from './2023/2023-awards-dropdown-menu';
import twentyAssets from './2020/2020-awards-dropdown-company-data';
import twentyOneAssets from './2021/2021-awards-dropdown-company-data';
import twentyTwoAssets from './2022/2022-awards-dropdown-company-data';
import twentyThreeAssets from './2023/2023-awards-dropdown-company-data';

export const DATA_SOURCE = {
  2020: twenty,
  2021: twentyOne,
  2022: twentyTwo,
  2023: twentyThree,
};

export const ASSETS_SOURCE = {
  2020: twentyAssets,
  2021: twentyOneAssets,
  2022: twentyTwoAssets,
  2023: twentyThreeAssets,
};
